module.exports = __webpack_public_path__ + "img/2IND.7ba34633.gif";